import React, { useContext } from 'react'
import { EditorialCard, Container, Row, Carousel } from '@mch-group/uikit-components'
import CustomLinkTag from '@components/CustomLinkTag'
import { cloudinary } from '@constants'
import Text from '@components/Text'
import { PageContext } from '@providers/PageContext'
import classNames from 'classnames'
import styled from 'styled-components'

const EMRecommendedForYou = (props) => {
  const {
    page: { siteLanguage }
  } = useContext(PageContext)
  const numberOfGroups = 3
  const data = Array.from({ length: numberOfGroups }, (_, index) => ({
    description: props[`emr_grp${index + 1}_body`],
    cta_href: props[`emr_grp${index + 1}_cta_href`],
    cta_label: props[`emr_grp${index + 1}_cta_label`],
    imageUrl: props[`emr_grp${index + 1}_img`],
    title: props[`emr_grp${index + 1}_title`],
    id: index
  }))

  return (
    <StyledContainer
      className={classNames('px-5 px-lg-8', siteLanguage === 'zh_CN' ? 'mb-7 mb-md-8' : 'mb-9 mb-md-12')}
    >
      <Row className='justify-content-center mt-0'>
        <Carousel
          title={props?.emr_grp1_section_title}
          editorialTitle={true}
          showCounter={true}
          showTopBorders={false}
          showBottomBorders={false}
          exceedTrack={false}
          // @ts-ignore
          cssStyles={{ marginTop: 0, paddingTop: 0, paddingBottom: 0 }}
        >
          {/* @ts-ignore */}
          {data?.map(
            (story) =>
              story?.title &&
              story?.description &&
              story?.imageUrl && (
                <Carousel.Slide key={story.id}>
                  <EditorialCard
                    linkRenderer={(link, children, linkTitle, ariaLabel) => (
                      <CustomLinkTag
                        url={link}
                        ariaLabel={ariaLabel}
                        title={linkTitle}
                        onClick={() => {
                          // Commented until we have confirmation of what exactly needs to be tracked
                          // Tracking.trackAction(41, story.id)
                        }}
                      >
                        {children}
                      </CustomLinkTag>
                    )}
                    layout='vertical'
                    link={story.cta_href}
                    size='large'
                    language={undefined}
                    textColour='black'
                    heading={story.title}
                    ctaLabel={story.cta_label}
                    a11yData={{
                      ariaLabel: story.title,
                      imageAlt: story.title
                    }}
                    //@ts-ignore
                    description={
                      <Text isHtml forwardedAs='p'>
                        {story.description}
                      </Text>
                    }
                    urlImage={`${cloudinary.throughCloudfront(
                      `https://res.cloudinary.com/${getEnvConfig.fe.cloudinary.name}/image/fetch/w_900,q_auto,f_auto/${story.imageUrl}`
                    )}`}
                  />
                </Carousel.Slide>
              )
          )}
        </Carousel>
      </Row>
    </StyledContainer>
  )
}

const StyledContainer = styled(Container)`
  .splide__arrows {
    @media (min-width: ${global.uikitVars.breakpointMdMax}) {
      display: none;
    }
  }
`

export default EMRecommendedForYou
